import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { XMarkIcon } from '@heroicons/react/24/outline';

export default function AdminNav({
  esMobile,
  tipo = 'panel',
  titulo = '',
  badges = [],
  volverRuta = '/admin',
  volverLabel = 'Admin',
  botonExtra = null,
}) {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <nav style={{
      background: '#FFFFFF', borderBottom: '1px solid #FBCFE8',
      padding: esMobile ? '0 14px' : '0 28px',
      height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      boxShadow: '0 2px 12px rgba(236,72,153,0.08)', gap: '8px',
      position: 'sticky', top: 0, zIndex: 100,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0, overflow: 'hidden' }}>
        {tipo === 'panel' ? (
          <>
            <span style={{ fontSize: '20px', flexShrink: 0 }}>🌸</span>
            {!esMobile && <span style={{ color: '#581C47', fontWeight: 700, fontSize: '15px', whiteSpace: 'nowrap' }}>Su Academia</span>}
            <span style={{ background: '#FCE7F3', color: '#EC4899', border: '1px solid #FBCFE8', borderRadius: '6px', padding: '2px 8px', fontSize: '11px', fontWeight: 700, flexShrink: 0 }}>ADMIN</span>
            {badges.map(b => (
              <span key={b.label} style={{
                background: b.bg, color: b.color, border: `1px solid ${b.border}`,
                borderRadius: '6px', padding: '2px 8px', fontSize: '11px', fontWeight: 700, flexShrink: 0,
                display: esMobile && b.hideMobile ? 'none' : undefined,
              }}>
                {b.label}
              </span>
            ))}
          </>
        ) : (
          <>
            <button
              onClick={() => navigate(volverRuta)}
              style={{ background: 'none', border: 'none', color: '#BE84A3', cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap', padding: 0 }}
            >
              ← {esMobile ? '' : volverLabel}
            </button>
            {!esMobile && <span style={{ color: '#FBCFE8' }}>|</span>}
            <span style={{ color: '#581C47', fontWeight: 600, fontSize: esMobile ? '14px' : '15px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {titulo}
            </span>
          </>
        )}
      </div>

      <div style={{ display: 'flex', gap: '8px', flexShrink: 0 }}>
        {botonExtra && (
          <button
            onClick={() => navigate(botonExtra.ruta)}
            style={{ background: 'none', border: '1px solid #FBCFE8', color: '#BE84A3', padding: '6px 12px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px', whiteSpace: 'nowrap' }}
          >
            {esMobile ? botonExtra.labelMobile : botonExtra.label}
          </button>
        )}
        <button
          onClick={() => { logout(); navigate('/'); }}
          style={{
            background: 'linear-gradient(135deg, #EC4899 0%, #F472B6 100%)',
            border: 'none', color: '#fff',
            padding: esMobile ? '7px 12px' : '8px 18px',
            borderRadius: '50px', fontSize: '13px', fontWeight: 600,
            cursor: 'pointer', whiteSpace: 'nowrap',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          {esMobile ? <XMarkIcon style={{ width: 16, height: 16 }} /> : 'Cerrar sesión'}
        </button>
      </div>
    </nav>
  );
}
